import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M12 1.5a.75.75 0 01.75.75V4.5a.75.75 0 01-1.5 0V2.25A.75.75 0 0112 1.5zM12 18.75a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V19.5a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M6.943 5.068a4.5 4.5 0 013.182-1.318H13.5a4.5 4.5 0 014.5 4.5.75.75 0 01-1.5 0 3 3 0 00-3-3h-3.375a3 3 0 100 6h4.125a4.5 4.5 0 110 9h-4.5a4.5 4.5 0 01-4.5-4.5.75.75 0 011.5 0 3 3 0 003 3h4.5a3 3 0 000-6h-4.125a4.5 4.5 0 01-3.182-7.682z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
